<script lang="ts">
	import { _ } from 'utils/i18/i18n';
	import LogoIcon from 'assets/svg/cryptomarketcapLogoWhite.svg?component';
	import LocaleLink from 'components/LocaleLink/LocaleLink.svelte';
	import userStore from 'stores/user';

	let Modal;
	let isModalActive = false;
	function toggleModal() {
		import('components/ModalAsyncSignInUpForgot/ModalAsyncSignInUpForgot.svelte').then(res => Modal = res.default)
		isModalActive = !isModalActive;
	}
</script>

<footer class="footer ">
	<div class="container wrapper">
		<div class="logo-wrapper">
			<LocaleLink href="/" label="CryptoMarketCap.com logo">
				<span class="logo-link-footer">
					<LogoIcon width="246" height="32" class="logo-icon" />
				</span>
			</LocaleLink>
		</div>
		<LocaleLink href="/newsletter/settings" handler={(e) => {
			!$userStore.isLoggedIn && e.preventDefault();
		}}>
			<span class="footer-link newsletter"
			on:click={() => {
				!$userStore.isLoggedIn ? toggleModal() : null;
			}}
			>{$_('footer.newsletter')}</span>
		</LocaleLink>

		<LocaleLink href="/contact-us">
			<span class="footer-link contact">{$_('footer.contactUs')}</span>
		</LocaleLink>

		<LocaleLink href="/privacy-policy">
			<span class="footer-link policy">{$_('footer.privacyPolicy')}</span>
		</LocaleLink>

		<LocaleLink href="/terms-of-service">
			<span class="footer-link terms">{$_('footer.termsOfServices')}</span>
		</LocaleLink>
	</div>
</footer>

<svelte:component this="{Modal}" bind:active={isModalActive} {toggleModal} />

<style lang="scss">
	@import 'footer';
</style>
